import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { IoArrowForward, IoPawOutline, IoQrCode } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useAuth } from "store/hooks/useAuth";
import { enabledModulesAccess } from "utils/modules-access";
import { getFullPathEnv } from "utils/pathEnv";

export const MenuList = () => {
  const usuario = useAuth();
  const navigate = useNavigate();

  function redirectLogin(to: string, routePublic = false) {
    if (usuario || routePublic) {
      navigate(to);
      return;
    }
    window.location.href = `${getFullPathEnv(
      "REACT_APP_IDENTITY_URL",
      `login?callbackUrl=${window.location.origin}${to}`
    )}`;
  }

  const menuServicos = [
    {
      titulo: "Meus animais",
      icon: IoPawOutline,
      to: "/zoonose",
      disabled: !enabledModulesAccess(["ZOONOSE"]),
      public: false
    },
    {
      titulo: "Validar Documento",
      icon: IoQrCode,
      to: "/servicos/validador",
      disabled: !enabledModulesAccess(["VALIDAR_DOCUMENTO"]),
      public: true
    }
  ];

  return (
    <HStack>
      {menuServicos
        .filter((x) => !x.disabled)
        .map((s) => (
          <Box
            key={s.titulo}
            p={3}
            borderRadius="md"
            bgColor="white"
            boxShadow="sm"
            w="150px"
            cursor="pointer"
            _hover={{ bgColor: "gray.50" }}
            onClick={() => redirectLogin(s.to, s.public)}
          >
            <HStack justifyContent="space-between" alignItems="flex-start">
              <VStack
                bgColor="gray.100"
                borderRadius="full"
                w="2.5rem"
                h="2.5rem"
                p={2}
              >
                <s.icon color="#e59560" size={20} />
              </VStack>
              <IoArrowForward color="#e59560" size={15} />
            </HStack>
            <Text fontSize="sm">{s.titulo}</Text>
          </Box>
        ))}
    </HStack>
  );
};
